import React, { useState, useCallback } from 'react'

import { func, string } from 'prop-types'

import DirectLinkCopyRow from './DirectLinkCopyRow'
import SocialNetworkRow from './SocialNetworkRow'

const DEFAULT_SETTINGS = {
  avatar: true,
  modelTitle: true,
  name: true,
  views: true,
  rating: true,
  likes: true,
  logo: true,
  button: true,
}

function EmbedSection({ renderCustomize, renderPreview, shareUrl = '' }) {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS)

  const handleSettingsChange = useCallback((newSettings) => {
    setSettings(newSettings)
  }, [])

  return (
    <div className="share-modal__embed-section">
      <div className="share-modal__embed-controls">
        {renderCustomize(settings, handleSettingsChange)}
        <SocialNetworkRow />
        <DirectLinkCopyRow url={shareUrl} />
      </div>
      {renderPreview(settings)}
    </div>
  )
}

EmbedSection.propTypes = {
  renderCustomize: func.isRequired,
  renderPreview: func.isRequired,
  shareUrl: string,
}

export default EmbedSection
